import styled from 'styled-components';

export const LogoutButton = styled.button`
    
    width: 100%;
    border-radius: 50px;
    padding: 10px 15px;
    font-weight: 600;
    background: #353535;
    color: #fff;
    border: none;
    margin: 10px 0;
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
        background: #454545;
    }

    i {
        margin-right: 5px;
    }

`;
